export default "__VITE_ASSET__DlbdJrgR__"